import { render } from "./FormEditCompanyPrimary.vue?vue&type=template&id=4812ba68"
import script from "./FormEditCompanyPrimary.vue?vue&type=script&lang=js"
export * from "./FormEditCompanyPrimary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__